import "../styles/siat-landing.css";
import { Navigation } from "../components/navigation";
import { Hero } from "../components/landing/Hero";
import { ValueProp } from "../components/landing/ValueProp";
import { Ecosystem } from "../components/landing/Ecosystem";
import { Comparison } from "../components/landing/Comparison";
import { Sectors } from "../components/landing/Sectors";
import { MediaBand } from "../components/landing/MediaBand";
import DownloadButtons from "../components/storeLinks";
import { Contact } from "../components/contact";
import { Footer } from "../components/landing/Footer";
import JsonData from "../data/data.json";

function Home() {
  return (
    <div className="siat-home">
      <Navigation />
      <Hero />
      <ValueProp />
      <Ecosystem />
      <Comparison />
      <Sectors />
      <MediaBand />
      <DownloadButtons />
      <Contact data={JsonData.Contact} />
      <Footer />
    </div>
  );
}

export default Home;
